import { DnDTools } from './DnDTools';

export class DnDDataChecker {

    public typeName?: string;

    public containsType(dataTransfer: DataTransfer): boolean {
        if (!this.typeName || this.typeName.length === 0) { throw new Error('typeName is not set'); }

        let mimeType = DnDTools.getMimeType(this.typeName);
        const types = dataTransfer.types;

        let result;
        if (types.findIndex) {
            result = dataTransfer.types
                .findIndex(x => x === mimeType) >= 0;
            if (!result) {
                mimeType = DnDTools.getMimeTypeForEdge(this.typeName);
                result = dataTransfer.types
                   .findIndex(x => x === mimeType) >= 0;
            }
        } else {
            result = true;
        }

        return result;
    }

}
